import loadInformer from "../../informer/loader";
import noop from "../../../lib/core/functional/noop";
import curry from "../../../lib/core/functional/curry";
import thunk from "../../../lib/core/functional/thunk";
import loadContextData from "../../../utils/loadContextData";
import raiseNotification from "../../../utils/raiseNotification";

import postMoveToSections from "../../../transport/postMoveToSections";

const DEFAULT_ERROR = "There was an error removing this post";

const INFORMER_CONFIG = {
    title: "Information",
    body: "Are you sure you want to delete this post?",
    negativeAction: {
        label: "Cancel",
        callback: noop,
    },
};

const sectionOtherThan = curry((sectionId, section) => section != sectionId);

const onSuccess = thunk((postElement) => {
    postElement.remove();
    raiseNotification("Post successfully removed", "success");
});

const onError = curry((postElement, error) => {
    postElement.classList.remove("hidden");
    raiseNotification(error.error || error.message || DEFAULT_ERROR, "error");
});

const removePostFrom = thunk((postElement, postId, sectionId) => {
    const postSectionsContext = loadContextData(`.post-context-${postId}`, postElement);

    if (!postSectionsContext || !postSectionsContext.post || !postSectionsContext.post.sections) {
        raiseNotification(DEFAULT_ERROR, "error");
        return;
    }

    const postSections = postSectionsContext.post.sections;

    postElement.classList.add("hidden");
    const desiredSections = postSections.filter(sectionOtherThan(sectionId));

    return postMoveToSections(postId, desiredSections)
        .then(onSuccess(postElement))
        .catch(onError(postElement));
});

function makePossitiveAction(context) {
    const { postId, sectionId, postElement } = context;
    return {
        label: "Remove",
        callback: removePostFrom(postElement, postId, sectionId),
    };
}

export default function remove(context) {
    loadInformer(context.appContext, {
        ...INFORMER_CONFIG,
        possitiveAction: makePossitiveAction(context),
    });
}
